import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from "@angular/common";

export enum CustomDateType {
  Time = 'time',
  DateTime = 'dateTime',
}

@Pipe({name: 'customDate'})
export class CustomDatePipe implements PipeTransform {
  private dateTimeFormat = 'MMMM d, y, h:mm a';
  private timeFormat = 'h:mm a';

  transform(date: Date | string, type: string = CustomDateType.DateTime,showZone: boolean = true): string {
    const datePipe = new DatePipe("en-US");
    const formattedTime = datePipe.transform(date, this.getFormat(type));

    if(showZone) {
      const timeZone = this.getTimeZoneAbbrevation();
      return `${formattedTime} ${timeZone}`;
    }else{
      return formattedTime;
    }
  }

  private getTimeZoneAbbrevation() {
    const { 1: timeZone } = new Date().toString().match(/\((.+)\)/);

    if (timeZone.includes(" ")) {
      return timeZone.split(" ").map(([first]) => first).join("");
    }

    return timeZone;
  }

  private getFormat(type: string) {
    if (type === CustomDateType.Time) {
      return this.timeFormat;
    }

    if (type === CustomDateType.DateTime) {
      return this.dateTimeFormat;
    }
  }
}
